import React from 'react'
import cx from 'classnames'

export default React.createClass({
  getInitialState () {
    return {
      showSuccess: false
    }
  },

  onSubmit (event) {
    this.props.handleSubmit(event)
      .then(() => this.setState({ showSuccess: true }))
      .then(() => setTimeout(() => this.setState({ showSuccess: false }), 1500))
  },

  render () {
    const {
      fields: {
        body
      },
      dirty,
      pristine
    } = this.props

    return (
      <form className={cx('micro-form', { dirty })} onSubmit={this.onSubmit}>
        <textarea
          style={{ fontStyle: body && body.value.length > 200 ? 'italic' : 'normal' }}
          placeholder='New message...' {...body} />
        {body && body.value.length > 200 && <span style={{ fontSize: 'small' }} >Please keep messages shorter than 200 characters</span>}
        <button
          disabled={!this.state.showSuccess && pristine}
          className={cx('button -primary small', { 'success': this.state.showSuccess })}
          type='submit'
        >
          {this.state.showSuccess
            ? '✓ Message Posted'
            : 'Post Message'}
        </button>
      </form>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/messages/quick-create-message-form.js